// BNB
export const DEFAULT_INPUT_CURRENCY = 'BCH' // todo xxxxxxxx
// FlexUSD
//export const DEFAULT_OUTPUT_CURRENCY = '0x7b2B3C5308ab5b2a1d9a94d20D35CCDf61e05b72' // todo xxxxxxxx
// 1BCH
export const DEFAULT_OUTPUT_CURRENCY = '0x77d4b6e44a53bbda9a1d156b32bb53a2d099e53d'
